export default "__VITE_ASSET__DLfFQKDh__"